import React from 'react';
import { Steps } from 'antd';
import {
  ArrowDown,
  ArrowUP,
  CheckCircle,
  FinariumLogoBg,
  Lava,
  MagmaLogoBg,
  MonestoLogoWhite,
  UnifyLogoBg,
} from 'IMAGE';
import './_registration-progress.less';
import '../../../styles/partials/_stepper.less';
import PropTypes from 'prop-types';

const { Step } = Steps;
const RegistrationProgress = ({ isLogin, step }) => {
  return (
    <div className='registration-wrapper'>
      <div className='content'>
        <div className='header'>
          <div className='title'>All Financial Solutions in One Place</div>
          <div className='subtitle'>Join FinClub today — register now and unlock your financial potential.</div>
        </div>

        <div className='footer'>
          <FinariumLogoBg />
          <MagmaLogoBg />
          <MonestoLogoWhite height={39} width={150} />
          <div className='unify'>
            <Lava />
          </div>
        </div>
      </div>
    </div>

    // <>
    //   {!isLogin ? (
    //     <div className="registration-wrapper">
    //       <div className="content">
    //         <div className="stepper-block">
    //           <div className="stepper-container">
    //             <Steps direction="vertical" current={step}>
    //               <Step
    //                 title={
    //                   <div className="step-header">
    //                       <div className='step-label'>STEP 1</div>
    //                       <div className='step-title'>Personal Information</div>
    //                     </div>
    //                   }
    //                   description='Please provide your basic information to get started'
    //                 />
    //                 <Step
    //                   title={
    //                     <div className='step-header'>
    //                       <div className='step-label'>STEP 2</div>
    //                       <div className='step-title'>Choose Your Spaces</div>
    //                     </div>
    //                   }
    //                   description='Select the types of spaces that best fit your needs. You can add more later.'
    //                 />
    //                 <Step
    //                   title={
    //                     <div className='step-header'>
    //                       <div className='step-label'>STEP 3</div>
    //                       <div className='step-title'>Confirm Your Email</div>
    //                     </div>
    //                   }
    //                   description="We've sent a verification link to your email address. Please click the link to continue."
    //                 />
    //                 <Step
    //                   title={
    //                     <div className='step-header'>
    //                       <div className='step-label'>STEP 4</div>
    //                       <div className='step-title'>Secure Your Account</div>
    //                     </div>
    //                   }
    //                   description='Add an extra layer of security to your account with Two-Factor Authentication (2FA).'
    //                 />
    //               </Steps>
    //             </div>
    //           </div>
    //           <div className='payments-section'>
    //             <div className='payments-header'>
    //               <h2 className='title'>All Financial Solutions in One Place</h2>
    //               <p className='subtitle'>Join FinClub today — register now and unlock your financial potential.</p>
    //             </div>
    //
    //             {/*<div className='payments-cards'>*/}
    //             {/*  <div className='card-notification second'>*/}
    //             {/*    <div className='icon-placeholder success-icon'>*/}
    //             {/*      <CheckCircle width={25} height={25} />*/}
    //             {/*    </div>*/}
    //             {/*    <div>*/}
    //             {/*      <div className='card-status'>Payment successfully sent</div>*/}
    //             {/*      <div className='card-text'>Payment details are available in the transaction section</div>*/}
    //             {/*    </div>*/}
    //             {/*  </div>*/}
    //
    //             {/*  <div className='card-block card-in first'>*/}
    //             {/*    <div className='icon-placeholder arrow-icon'>*/}
    //             {/*      <ArrowUP width={15} height={15} />*/}
    //             {/*    </div>*/}
    //             {/*    <div className='card-content'>*/}
    //             {/*      <div className='card-date'>03/06/25 | 09:45:27</div>*/}
    //             {/*      <div className='card-desc'>to HoReCa Service</div>*/}
    //             {/*    </div>*/}
    //             {/*    <div className='card-amount'>¥10 654.00</div>*/}
    //             {/*  </div>*/}
    //
    //             {/*  <div className='card-block card-in third'>*/}
    //             {/*    <div className='icon-placeholder arrow-icon'>*/}
    //             {/*      <ArrowUP width={15} height={15} />*/}
    //             {/*    </div>*/}
    //             {/*    <div className='card-content'>*/}
    //             {/*      <div className='card-date'>30/05/25 | 23:59:59</div>*/}
    //             {/*      <div className='card-desc'>to LTP Construction</div>*/}
    //             {/*    </div>*/}
    //             {/*    <div className='card-amount negative'>-€5 768.69</div>*/}
    //             {/*  </div>*/}
    //
    //             {/*  <div className='card-block card-in fourth'>*/}
    //             {/*    <div className='icon-placeholder positive arrow-icon'>*/}
    //             {/*      <ArrowDown width={15} height={15} />*/}
    //             {/*    </div>*/}
    //             {/*    <div className='card-content'>*/}
    //             {/*      <div className='card-date'>15/11/25 | 14:30:15</div>*/}
    //             {/*      <div className='card-desc'>from HUB Center</div>*/}
    //             {/*    </div>*/}
    //             {/*    <div className='card-amount positive'>+$38 000</div>*/}
    //             {/*  </div>*/}
    //             {/*</div>*/}
    //           </div>
    //         </div>
    //       </div>
    //     ) : (
    //       <div className='registration-wrapper'>
    //         <div className='content'>
    //           <div className='header'>
    //             <div className='title'>All Financial Solutions in One Place</div>
    //             <div className='subtitle'>Join FinClub today — register now and unlock your financial potential.</div>
    //           </div>
    //
    //         </div>
    //       </div>
    //     )}
    //   </>
  );
};

export default RegistrationProgress;

RegistrationProgress.propTypes = {
  step: PropTypes.number,
  isLogin: PropTypes.bool,
};
